import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { CNavGroup, CNavItem, CSidebar, CSidebarNav } from "@coreui/react";

import menuItems from "config/menuItems";
import { LayoutContext } from "./context/LayoutContext";
import { SvgIcon } from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ChatIcon from "@mui/icons-material/Chat";
import ApartmentIcon from "@mui/icons-material/Apartment";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import HandymanIcon from "@mui/icons-material/Handyman";
import SelectAllIcon from "@mui/icons-material/SelectAll";
import PeopleIcon from "@mui/icons-material/People";
import RuleIcon from "@mui/icons-material/Rule";
import BoltIcon from "@mui/icons-material/Bolt";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import DevicesIcon from "@mui/icons-material/Devices";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import BalanceIcon from "@mui/icons-material/Balance";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import SummarizeIcon from "@mui/icons-material/Summarize";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import TuneIcon from "@mui/icons-material/Tune";
import ListAltIcon from "@mui/icons-material/ListAlt";
import GroupsIcon from "@mui/icons-material/Groups";
import DynamicFeedIcon from "@mui/icons-material/DynamicFeed";
import EngineeringIcon from "@mui/icons-material/Engineering";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import SettingsIcon from "@mui/icons-material/Settings";
import CelebrationIcon from "@mui/icons-material/Celebration";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import BuildIcon from "@mui/icons-material/Build";
import CategoryIcon from "@mui/icons-material/Category";
import AgricultureIcon from '@mui/icons-material/Agriculture';
import FolderZipIcon from '@mui/icons-material/FolderZip';

const Sidebar = () => {
  const { layoutState, onToggleSidebar, me } = useContext(LayoutContext);
  const menuItemsSales = menuItems.filter(
    (item) => !!item.isAllowed(me.permissions) && item.category === "sales"
  );
  const menuItemsMonitoring = menuItems.filter(
    (item) => !!item.isAllowed(me.permissions) && item.category === "monitoring"
  );
  const menuItemsMaintenance = menuItems.filter(
    (item) =>
      !!item.isAllowed(me.permissions) && item.category === "maintenance"
  );
  const menuItemsAnalytics = menuItems.filter(
    (item) => !!item.isAllowed(me.permissions) && item.category === "analytics"
  );
  const menuItemsAgro = menuItems.filter(
    (item) => !!item.isAllowed(me.permissions) && item.category === "agro"
  );
  const menuItemsSettings = menuItems.filter(
    (item) => !!item.isAllowed(me.permissions) && item.category === "settings"
  );

  const getIcon = (icon) => {
    const avilableIcons = {
      StorefrontIcon,
      TrackChangesIcon,
      DashboardIcon,
      ChatIcon,
      ApartmentIcon,
      NotificationImportantIcon,
      BlurOnIcon,
      HandymanIcon,
      SelectAllIcon,
      PeopleIcon,
      RuleIcon,
      BoltIcon,
      ViewInArIcon,
      ViewKanbanIcon,
      DevicesIcon,
      AssignmentIcon,
      CalendarMonthIcon,
      HomeRepairServiceIcon,
      BalanceIcon,
      QueryStatsIcon,
      StackedLineChartIcon,
      SummarizeIcon,
      UpgradeIcon,
      TuneIcon,
      ListAltIcon,
      GroupsIcon,
      CelebrationIcon,
      AttachMoneyIcon,
      BuildIcon,
      EngineeringIcon,
      CategoryIcon,
      AgricultureIcon,
      FolderZipIcon
    };
    return avilableIcons[icon];
  };

  return (
    <CSidebar
      visible={layoutState.sidebarVisible}
      onVisibleChange={onToggleSidebar}
      position="fixed"
      style={styles.sidebar}
    >
      <CSidebarNav>
        {menuItemsSales.length > 0 && (
          <CNavGroup
            toggler={
              <>
                <SvgIcon component={LoyaltyIcon} style={styles.icon} /> Ventas y
                Comunicaciones
              </>
            }
          >
            {menuItemsSales.map((item, index) => (
              <CNavItem
                key={index}
                to={item.to}
                component={NavLink}
                style={styles.navLinkItem}
              >
                <SvgIcon component={getIcon(item.icon)} style={styles.icon} />
                {item.name}
              </CNavItem>
            ))}
          </CNavGroup>
        )}
        {menuItemsMonitoring.length > 0 && (
          <CNavGroup
            toggler={
              <>
                <SvgIcon component={DynamicFeedIcon} style={styles.icon} />{" "}
                Monitoreo y Control
              </>
            }
          >
            {menuItemsMonitoring.map((item, index) => (
              <CNavItem
                key={index}
                to={item.to}
                component={NavLink}
                style={styles.navLinkItem}
              >
                <SvgIcon component={getIcon(item.icon)} style={styles.icon} />
                {item.name}
              </CNavItem>
            ))}
          </CNavGroup>
        )}
        {menuItemsMaintenance.length > 0 && (
          <CNavGroup
            toggler={
              <>
                <SvgIcon component={EngineeringIcon} style={styles.icon} />{" "}
                Mantenimiento
              </>
            }
          >
            {menuItemsMaintenance.map((item, index) => (
              <CNavItem
                key={index}
                to={item.to}
                component={NavLink}
                style={styles.navLinkItem}
              >
                <SvgIcon component={getIcon(item.icon)} style={styles.icon} />
                {item.name}
              </CNavItem>
            ))}
          </CNavGroup>
        )}
        {menuItemsAnalytics.length > 0 && (
          <CNavGroup
            toggler={
              <>
                <SvgIcon component={AutoGraphIcon} style={styles.icon} />{" "}
                Analítica
              </>
            }
          >
            {menuItemsAnalytics.map((item, index) => (
              <CNavItem
                key={index}
                to={item.to}
                component={NavLink}
                style={styles.navLinkItem}
              >
                <SvgIcon component={getIcon(item.icon)} style={styles.icon} />
                {item.name}
              </CNavItem>
            ))}
          </CNavGroup>
        )}
        {menuItemsAgro.length > 0 && (
          <CNavGroup
            toggler={
              <>
                <SvgIcon component={AgricultureIcon} style={styles.icon} />{" "}
                Agro
              </>
            }
          >
            {menuItemsAgro.map((item, index) => (
              <CNavItem
                key={index}
                to={item.to}
                component={NavLink}
                style={styles.navLinkItem}
              >
                <SvgIcon component={getIcon(item.icon)} style={styles.icon} />
                {item.name}
              </CNavItem>
            ))}
          </CNavGroup>
        )}
        {menuItemsSettings.length > 0 && (
          <CNavGroup
            toggler={
              <>
                <SvgIcon component={SettingsIcon} style={styles.icon} />{" "}
                Configuración
              </>
            }
          >
            {menuItemsSettings.map((item, index) => (
              <CNavItem
                key={index}
                to={item.to}
                component={NavLink}
                style={styles.navLinkItem}
              >
                <SvgIcon component={getIcon(item.icon)} style={styles.icon} />
                {item.name}
              </CNavItem>
            ))}
          </CNavGroup>
        )}
      </CSidebarNav>
    </CSidebar>
  );
};

const styles = {
  sidebar: {
    backgroundColor: "#e4e4e4",
    marginTop: "56px",
    marginBottom: "47px",
    width: "350px",
  },
  navLinkItem: {
    textDecoration: "none",
    color: "#000000",
  },
  icon: {
    marginRight: "7px",
    color: "#000000",
  },
};

export default Sidebar;
